export enum Illustration {
    BothPayment = 'both-payment',
    OneTimePayment = 'one-time-payment',
    MonthlyPayment = 'monthly-payment',

    Branch21Product = 'br21-product',
    Branch23Product = 'br23-product',

    NegativeScenario = 'negative-scenario',
    NeutralScenario = 'neutral-scenario',
    PositiveScenario = 'positive-scenario',
    StressScenario = 'stress-scenario',
    AGpicto10Pizza = 'pizza-slice',
    PlantGrowth = 'plant-growth',
    CoffeeTime = 'coffee-time',

    BrokerHandshake = 'broker-handshake',
    FindBrokerHandshake = 'find-broker-handshake',
    RiskGraph1 = 'Risk-Graph1',
    RiskGraph2 = 'Risk-Graph2',
    RiskGraph3 = 'Risk-Graph3',
    RiskGraph4 = 'Risk-Graph4',
    RecommendedBadge = 'recommended-badge',
    PracticalTip = 'practical-tip',
    CoinsAlt = 'coins-alt',
    MoneyBagAlt = 'money-bag-alt',
    SmallUppieFamily = 'icon-picto-small-uppie-family',
    Document = 'icon-picto-small-uppie-document',
    Medal = 'icon-picto-small-uppie-medal',
    creditCard = 'icon-picto-small-uppie-creditcard',
    Questionaire = 'icon-picto-small-uppie-questionaire',
    Calender = 'icons-ico-32-calendar',
    Communication = 'icons-ico-32-communication',
    Tip = 'icons-ico-32-lightbulb',
    AddSimulation = 'add-simulation',
    noSimulation = 'no-simulation-icon',
    Phone = 'icon-11-phone',
    Email = 'icon-11-email',
    Web = 'icon-11-web',
    Mobile = 'phone',
    EmailEnvelope = 'email-envelope',
    ProductsGraph = 'uppie-products-graph',
    ProductsGraphBroker = 'broker-products-graph',
    Location = 'location-pin',
    WebsiteGlobe = 'website-globe',
    MailEnvelope = 'mail-envelope',
    MobilePhone = 'mobile-phone',
    Beneficiary = 'beneficiary',
    Coin = 'coin',
    Duration = 'duration',
    FeesAndTaxes = 'fees-and-taxes',
    ReturnsAndRisks = 'returns-and-risks',
    OneTimePaymentBlue = 'one-time-payment-info',
    MonthlyPaymentBlue = 'monthly-payment-info',
    RiskGraph1Fr = 'graph-1-risk-question-fr',
    RiskGraph2Fr = 'graph-2-risk-question-fr',
    RiskGraph3Fr = 'graph-3-risk-question-fr',
    RiskGraph4Fr = 'graph-4-risk-question-fr',
    RiskGraph1Nl = 'graph-1-risk-question-nl',
    RiskGraph2Nl = 'graph-2-risk-question-nl',
    RiskGraph3Nl = 'graph-3-risk-question-nl',
    RiskGraph4Nl = 'graph-4-risk-question-nl',
    ContactPhone = 'contact-phone',
    ContactChat = 'contact-chat',
    ContactEmail = 'contact-email',
    Close = 'icon-font-icon-close',
    Info = 'icon-font-icon-info',
    InProgress = 'in-progress-tick',
    LargeUppieFamilyWithShield = 'icon-picto-large-family-shield',
    Sustainability01 = 'icon-picto-small-uppie-sustainability-01',
    Sustainability02 = 'icon-picto-small-uppie-sustainability-02',
    Sustainability03 = 'icon-picto-small-uppie-sustainability-03',
    Question = 'question-mark',
    Processing = 'icon-hourglass-wait',
    BarYongoMoonProfit = 'graph-yongo-moon-profit',
    BarYongoMoonLose = 'graph-yongo-moon-lose',
    BarYongoStarProfit = 'graph-yongo-star-profit',
    BarYongoStarLose = 'graph-yongo-star-lose',
    GraghYongoStarFr = 'graph-detail-yongo-star-desktop-fr',
    GraghYongoStarNl = 'graph-detail-yongo-star-desktop-nl',
    GraghYongoMoonFr = 'graph-detail-yongo-moon-desktop-fr',
    GraghYongoMoonNl = 'graph-detail-yongo-moon-desktop-nl',
    Kind = 'icon-begunstigde-kind',
    InfoIcon = 'info-icon',
    CaptureChildDetail = 'capture-child-details',
    ExclamationMark = 'exclamation-mark',
    CopyToClipBoard = 'copy-to-clipboard',
    PromoCodeIcon = 'percentage-in-circle',
    GiftIcon = 'gift'
}
